import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgPrinterIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 10.667A2.667 2.667 0 0 1 18.667 8h26.667A2.667 2.667 0 0 1 48 10.667v10.666h10.667A2.667 2.667 0 0 1 61.334 24v18.667a2.667 2.667 0 0 1-2.667 2.666h-8v8A2.667 2.667 0 0 1 48 56H16a2.667 2.667 0 0 1-2.666-2.667v-8h-8a2.667 2.667 0 0 1-2.667-2.666V24a2.667 2.667 0 0 1 2.667-2.667H16zm2.667 10.666h26.667V10.667H18.667zm-5.333 21.334v-8A2.667 2.667 0 0 1 16 32h32a2.667 2.667 0 0 1 2.667 2.667v8h8V24H5.334v18.667zm34.666-8H16v18.666h32zm-8 10.666H24v-2.666h16z"
    />
  </svg>
)
export default SvgPrinterIcon
